import { render, staticRenderFns } from "./stadium_count.vue?vue&type=template&id=0fc561d6&"
import script from "./stadium_count.vue?vue&type=script&lang=ts&"
export * from "./stadium_count.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports